import styled, { css } from 'styled-components';
import Button from '~/components/Button';
import { ModalParagraph as _ModalParagraph } from '~/components/Text';

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  position: fixed;
`;

export const SignUpCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  overflow: auto;
  padding: 64px;
`;

export const SignUpCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${props => props.theme.lightest};
  overflow-y: auto;
  z-index: 2;
  max-width: 36rem;
  height: 90%;
  max-height: 902px;
  border-radius: 1rem;
  @media (min-width: 10rem) {
    width: 504px;
  }
  @media (max-height: 900px) {
    width: 33rem;
  }
`;

export const SignUpFadeOut = styled.div`
  pointer-events: none;
  position: absolute;
  height: 64px;
  width: calc(100% - 20px);
  bottom: 0;
  left: 0;
  background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255, 0.95) 70%);
`;

export const OnoLogo = styled.img`
  width: 158px;
  position: absolute;
  left: 80px;
  top: 40px;
`;

export const StyledForm = styled.form`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
  ${props => props.marginBottom && `margin-bottom: ${props.marginBottom}px;`}
`;

export const ContinueBtn = styled(Button)`
  display: flex;
  width: 100%;
  height: 2.85rem;
  background-color: black;
  color: white;
  border-radius: 2.15rem;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const StyledCheckbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: var(--accent-9);
`;

export const AllowDataProcessing = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-align: start;
  color: ${props => props.theme.dark};
  margin-top: 24px;
  @media (max-height: 900px) {
    margin: 1rem 0;
  }
`;

export const DataProcessingContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CheckboxError = styled.p`
  color: ${props => props.theme.danger};
`;

export const GoBackBtn = styled.button`
  color: ${props => props.theme.darkMedium};
  margin-top: 16px;
  margin-bottom: 64px;
  background-color: white;
  border: none;
  display: flex;
  justify-content: center;
  font-size: 14px;
  gap: 0.35rem;
  font-weight: 500;
  &:hover {
    cursor: pointer;
  }
`;

export const StyledLink = styled.a`
  color: var(--accent-9);
  &:hover {
    cursor: pointer;
  }
`;

export const VerifyEmailContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 40px;
  gap: 8px;
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
`;

export const EyeIcon = styled.div`
  position: absolute;
  right: 14px;
  top: 28px;
  cursor: pointer;
`;

export const StyledLabelSpan = styled.span`
  align-self: ${props => props.align};
  display: flex;
`;

export const StyledLabelContainer = styled.p`
  color: ${props => (props.disabled ? props.theme.lightMedium : props.theme.darkest)};
  font-size: 12px;
  margin-left: 5px;
`;

export const StyledTextWrapper = styled.div`
  margin-top: 48px;
  margin-bottom: 40px;
`;

export const SubTitleWrapper = styled.div`
  margin-bottom: 48px;
`;

export const StyledContinueBtnWrapper = styled.div`
  width: 100%;
  margin-top: 24px;
`;

export const SimpleInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TopOfForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MidOfForm = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const BottomOfForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const messageBaseCss = css`
  padding: ${props => props.theme.spacing[3]};
  border: 1px solid;
  border-radius: ${props => props.theme.radius[3]};
  gap: 8px;
`;

export const SuccessMessage = styled.div`
  ${messageBaseCss}
  background-color: var(--success-2);
  border-color: var(--success-6);
`;

export const InfoMessage = styled.div`
  ${messageBaseCss}
  background-color: var(--neutral-2);
  border-color: var(--neutral-6);
`;

export const WarningMessage = styled.div`
  ${messageBaseCss}
  background-color: var(--warning-2);
  border-color: var(--warning-6);
`;

export const ErrorMessage = styled.div`
  ${messageBaseCss}
  background-color: var(--error-2);
  border-color: var(--error-6);
`;

export const PromotionMessage = styled.div`
  ${messageBaseCss}
  background-color: var(--accent-2);
  border-color: var(--accent-6);
`;

export const MessageTop = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing[2]};

  &:not(:last-child) {
    margin-bottom: ${props => props.theme.spacing[2]};
  }
`;

export const MessageButton = styled(Button)`
  width: 100%;
  background-color: var(--neutral-a3);
  border-radius: ${props => props.theme.radius.full};
`;

export const ModalParagraph = styled(_ModalParagraph)`
  text-align: center;
  color: var(--neutral-11);
`;
